class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.initTagFilter();
  }

  initTagFilter() {
    const tagLabel = this.querySelector(".main-blog__tags-label");
    const tagContainer = this.querySelector(".main-blog__tags-container");

    if (tagLabel && tagContainer) {
      tagLabel.addEventListener("click", () => {
        tagContainer.classList.toggle("visible");
        tagLabel.classList.toggle("rotated");
      });
    }
  }

  connectedCallback() {
    document.addEventListener("click", (event) => {
      const tagLabel = this.querySelector(".main-blog__tags-label");
      const tagContainer = this.querySelector(".main-blog__tags-container");

      if (!tagLabel || !tagContainer) return;

      if (
        !tagLabel.contains(event.target) &&
        !tagContainer.contains(event.target)
      ) {
        tagContainer.classList.remove("visible");
        tagLabel.classList.remove("rotated");
      }
    });
  }
}

customElements.define("main-blog", MainBlog);
